

  document.addEventListener('DOMContentLoaded', () => {
    const modal = document.getElementById('custom-modal');
    const closeButton = document.getElementById('close-modal');

    // Select all buttons with the class "modal-trigger"
    const modalTriggers = document.querySelectorAll('.modal-trigger');

    const openModal = () => {
        modal.style.display = 'flex';
    };

    const closeModal = () => {
        modal.style.display = 'none';
    };

    // Add event listeners to all modal trigger buttons
    modalTriggers.forEach(trigger => {
        trigger.addEventListener('click', openModal);
    });

    // Add an event listener for anchor links or buttons with "Book Now" (case-insensitive)
document.body.addEventListener('click', event => {
    const target = event.target;
    if (
        (target.tagName === 'A' || target.tagName === 'BUTTON') && 
        target.innerHTML.trim().toLowerCase() === 'book now'
    ) {
        event.preventDefault(); // Prevent default action, such as following an href
        openModal(); // Trigger the modal
    }
});

    // Close modal when clicking close button
    closeButton.addEventListener('click', closeModal);
});






  let draftOrderCreated = false; // Flag to track if draft order is created


function seePrices(event) {



  var cardError = document.getElementById("card-errors").innerHTML = "";

  // List of field IDs to watch for changes
const fields = [
    'fname',
    'lname',
    'phone',
    'email',
    'destination2',
    'destination1',
    'pickupDate',
    'pickupTime'
];

// Function to reset draftOrderCreated when any field changes
const resetDraftOrder = () => {
    draftOrderCreated = false;
    console.log("Field changed. draftOrderCreated reset to false.");


};

// Attach event listeners to all fields
fields.forEach(fieldId => {
    const field = document.getElementById(fieldId);
    if (field) {
        field.addEventListener('input', function() { resetDraftOrder; field.classList.remove("glass-form-input-err"); });
        field.addEventListener('change', function() { resetDraftOrder; field.classList.remove("glass-form-input-err"); });

   
    }
});

                document.getElementById("submit-button").setAttribute("disabled","disabled");
                document.getElementById("submit-button").innerHTML = "processing...";
                document.getElementById("submit-button").classList.add("card-submit-animate");

                    document.getElementById("seePrices").setAttribute("disabled","disabled");
                document.getElementById("seePrices").innerHTML = "calculating price...";
                document.getElementById("seePrices").classList.add("card-submit-animate"); 

      let emailInput = document.getElementById('email').value.trim(); // Get the email value and trim spaces
    let emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email validation regex

        if(document.getElementById('phone').value == "" || 
           document.getElementById('email').value == "" ||
           document.getElementById('fname').value == "" ||
           document.getElementById('lname').value == "" 
        ){
            
            if(document.getElementById('phone').value == "") { 
                
                document.getElementById('phone').classList.add("glass-form-input-err"); 
            } 
            
            if(document.getElementById('email').value == "") {
                
            document.getElementById('email').classList.add("glass-form-input-err"); 
            } 
            
            if(document.getElementById('fname').value == "") { 
                
                                document.getElementById('fname').classList.add("glass-form-input-err"); 
                } 
            
            if (document.getElementById('lname').value == "") { 
                
                                document.getElementById('lname').classList.add("glass-form-input-err"); 
            }
            
           document.getElementById('card-errors').innerHTML = "<span class='card-error'>Passenger details missing</span>"; 
           
                document.getElementById("submit-button").setAttribute("disabled","disabled");
                document.getElementById("submit-button").innerHTML = "Pay Now";
                document.getElementById("submit-button").classList.add("card-submit-animate");

                document.getElementById("seePrices").removeAttribute("disabled");
                document.getElementById("seePrices").innerHTML = "See Prices";
                document.getElementById("seePrices").classList.remove("card-submit-animate"); 
            
        } else if(!emailRegex.test(emailInput)) {

          document.getElementById('email').classList.add("glass-form-input-err");

                     document.getElementById('card-errors').innerHTML = "<span class='card-error'>Passenger email format is wrong</span>"; 
           
                document.getElementById("submit-button").setAttribute("disabled","disabled");
                document.getElementById("submit-button").innerHTML = "Pay Now";
                document.getElementById("submit-button").classList.add("card-submit-animate"); 

                document.getElementById("seePrices").removeAttribute("disabled");
                document.getElementById("seePrices").innerHTML = "See Prices";
                document.getElementById("seePrices").classList.remove("card-submit-animate"); 
        } else {


          //Create Details to Shopify 

          localStorage.setItem("first_name", document.getElementById('fname').value ); 
          localStorage.setItem("last_name", document.getElementById('lname').value); 
          localStorage.setItem("phone", document.getElementById('phone').value); 
          localStorage.setItem("email", document.getElementById('email').value); 
   
          
    var toggle1 = document.getElementById('toggle1');
    var toggle2 = document.getElementById('toggle2');
    var location1 = document.getElementById('destination1');
    var location2 = document.getElementById('destination2');
    var pickupTime = document.getElementById('pickupTime'); 
    var pickupDate = document.getElementById('pickupDate');
    
    if(location2.value == undefined || location2.value == "") { 
        
               location2.classList.add("glass-form-input-err");  
                               console.log(location2.value); 
                               console.log(location1.value); 

                document.getElementById('email').classList.add("glass-form-input-err");

                     document.getElementById('card-errors').innerHTML = "<span class='card-error'>Destination is missing</span>"; 
           
                document.getElementById("submit-button").setAttribute("disabled","disabled");
                document.getElementById("submit-button").innerHTML = "Pay Now";
                document.getElementById("submit-button").classList.add("card-submit-animate"); 

                      document.getElementById("seePrices").removeAttribute("disabled");
                document.getElementById("seePrices").innerHTML = "See Prices";
                document.getElementById("seePrices").classList.remove("card-submit-animate"); 
        
    } 
else { 
        
                       location2.classList.remove("glass-form-input-err");
        
        localStorage.setItem("location1", location1); 
        localStorage.setItem("location2", location2); 
        localStorage.setItem("toggle1", toggle1); 
        localStorage.setItem("toggle2", toggle2); 
        localStorage.setItem("pickupTime", pickupTime.value); 
        localStorage.setItem("pickupDate", pickupDate.value);


                // Toggle the checked states with IDs
        
                var clickedId = event.target; 
        clickedId.setAttribute("data-toggle", "modal"); 
        clickedId.setAttribute("data-target", "#videoTabModal");
        
        
    
        
        
        
        
        /* Google Maps Calculator */ 
        
 
        if(location1.tagName === 'SELECT') {
            
        var location1Long = location1.options[location1.selectedIndex].getAttribute('long'); 
        var location1Lat = location1.options[location1.selectedIndex].getAttribute('lat');
       var location2Long = location2.getAttribute("long"); 
       var location2Lat = location2.getAttribute("lat");
            
            
        }
        
        else if(location2.tagName === 'SELECT') {
            
        var location2Long = location2.options[location2.selectedIndex].getAttribute('long'); 
        var location2Lat = location2.options[location2.selectedIndex].getAttribute('lat');
       var location1Long = location1.getAttribute("long"); 
       var location1Lat = location1.getAttribute("lat");    
            
        }

        
        if(toggle1.value == "on") { 
            
          var origin = new google.maps.LatLng(location1Lat, location1Long);
          var destination = new google.maps.LatLng(location2Lat, location2Long);  
          
          console.log("show "+origin+" "+destination); 
                localStorage.setItem("pickup_location", origin);
                localStorage.setItem("dropoff_location", destination); 
            
        } else { 
            
          var origin = new google.maps.LatLng(location2Lat, location2Long);
          var destination = new google.maps.LatLng(location1Lat, location1Long);
            
                      console.log("show 1"+origin+" "+destination); 
                          localStorage.setItem("pickup_location", origin);
                localStorage.setItem("dropoff_location", destination); 
            
        }
        

function geocodeAddress(address, type) {
    var geocoder = new google.maps.Geocoder();

    geocoder.geocode({ address: address }, function (results, status) {
        if (status === "OK" && results[0]) {
            let components = results[0].address_components;
            let parsedAddress = {};

            components.forEach((component) => {
                let type = component.types[0]; // Primary type of component
                parsedAddress[type] = component.long_name; // Save long name of each component
            });

            console.log(type + " Address Parsed:", parsedAddress);

            // Save to local storage
            localStorage.setItem(type + "_address", JSON.stringify(parsedAddress));
        } else {
            console.error("Geocode failed for " + address + ": " + status);
        }
    });
}

function initialize(location2Lat, location2Long, location1Lat, location1Long) {
  // create a new map object
  // set the div id where it will be shown
  // set the map options
  var mapOptions = {
    center: {
      lat: 42,
      lng: -72
    },
    zoom: 4
  }
  map = new google.maps.Map(document.getElementById("map_canvas"), mapOptions);

  // show route between the points
  directionsService = new google.maps.DirectionsService();
  directionsDisplay = new google.maps.DirectionsRenderer({
    suppressMarkers: true,
    suppressInfoWindows: true
  });
  directionsDisplay.setMap(map);


  var request = {
    origin: origin,
    destination: destination,
    travelMode: google.maps.DirectionsTravelMode.DRIVING
  };

  directionsService.route(request, function(response, status) {
    if (status == google.maps.DirectionsStatus.OK) {
      directionsDisplay.setDirections(response);
      var route = response.routes[0];
      
          var routeDirection = document.getElementById('toggle1');

      // For each route, display summary information.
      for (var i = 0; i < route.legs.length; i++) {
          
          console.log(route.legs[i]); 

                let leg = route.legs[i];

        // Extract start and end addresses
        let startAddress = leg.start_address;
        let endAddress = leg.end_address;

        console.log("Start Address:", startAddress);
        console.log("End Address:", endAddress);

            localStorage.setItem("totalDistance", route.legs[i].distance.text); 
            localStorage.setItem("totalTime", route.legs[i].duration.text); 

document.getElementById("totalDistance").innerHTML = route.legs[i].distance.text; 
         document.getElementById("totalDuration").innerHTML = route.legs[i].duration.text; 
         
         document.getElementById("viewPickupDate").innerHTML = document.getElementById("pickupDate").value; 
         document.getElementById("viewPickupTime").innerHTML = document.getElementById("pickupTime").value;
         
         if(routeDirection.value == "on") {
             
        document.getElementById("originAddress").innerHTML = route.legs[i].start_address; 
         document.getElementById("destinationAddress").innerHTML = route.legs[i].end_address; 
         
                 document.getElementById("originAddress").setAttribute("originLat",location1Lat); 
                document.getElementById("originAddress").setAttribute("originLong",location1Long); 
                
         document.getElementById("destinationAddress").setAttribute("destinationLat",location2Lat);
         document.getElementById("destinationAddress").setAttribute("destinationLong",location2Long);
             
                     // Optionally use Google Maps Geocoder to break down address components
        geocodeAddress(startAddress, "start");
        geocodeAddress(endAddress, "end");

            localStorage.setItem("pickupAddress", startAddress); 
            localStorage.setItem("dropoffAddress", endAddress); 
             
         } else { 
             
                     document.getElementById("originAddress").innerHTML = route.legs[i].end_address; 
         document.getElementById("destinationAddress").innerHTML = route.legs[i].start_address; 
         
         
                          document.getElementById("originAddress").setAttribute("originLat",location2Lat); 
                document.getElementById("originAddress").setAttribute("originLong",location2Long); 
                
         document.getElementById("destinationAddress").setAttribute("destinationLat",location1Lat);
         document.getElementById("destinationAddress").setAttribute("destinationLong",location1Long);

                                // Optionally use Google Maps Geocoder to break down address components
        geocodeAddress(startAddress, "end");
        geocodeAddress(endAddress, "start");

                       localStorage.setItem("pickupAddress", endAddress); 
            localStorage.setItem("dropoffAddress", startAddress); 
             
             
         }       
         

          
      }
      
      computeTotalDistance(response);
      
     /* 
     
      var request = {
        origin: location2,
        destination: location3,
        travelMode: google.maps.DirectionsTravelMode.DRIVING
      };
      
      
      directionsService.route(request, function(response, status) {
        if (status == google.maps.DirectionsStatus.OK) {
          var distance = response.routes[0].legs[0].distance.value / 1000;
          var duration = response.routes[0].legs[0].duration.text;
          var dvDistance = document.getElementById("dvDistance");
          dvDistance.innerHTML = "";
          dvDistance.innerHTML += "The one way Distance (segment 2) is: " + distance + "<br />";
          dvDistance.innerHTML += "The one way Duration (segment 2) is: " + duration;

          //calculate the one way price using the klms
          var kms = distance;
          console.log(kms);
          var price_1 = (kms > 0) ? 3 : 0;
          kms = (kms > 0) ? kms - 1 : 0;
          var price_2 = (kms - 14) > 0 ? (14 * 1.60) : (kms * 1.60);
          kms = (kms - 14) > 0 ? kms - 14 : 0;
          var price_3 = (kms - 15) > 0 ? (15 * 1.40) : (kms * 1.40);
          kms = (kms - 15) > 0 ? kms - 15 : 0;
          var price_4 = (kms > 0) ? (kms * 1.20) : 0;

          document.getElementById("displayprice").innerHTML = "the one way price (segment 2) is: $" + (price_1 + price_2 + price_3 + price_4).toFixed(2);
        }
      });
      
      
      */ 
      
      
    } else {
      alert("directions response " + status);
    }
  });
}



initialize(location2Lat, location2Long, location1Lat, location1Long); 




function computeTotalDistance(result) {
  var totalDist = 0;
  var totalTime = 0;
  var myroute = result.routes[0];
  for (i = 0; i < myroute.legs.length; i++) {
    totalDist += myroute.legs[i].distance.value;
    totalTime += myroute.legs[i].duration.value;
  }

  var weekdayPrice = parseInt(((totalTime / 60).toFixed(2) * 2.1)); 
  var saturdayPrice = parseInt(((totalTime / 60).toFixed(2) * 2.35));
  var sundayPrice = parseInt(((totalTime / 60).toFixed(2) * 2.60));
  
  document.getElementById("totalPrice").innerHTML = weekdayPrice; 
  document.getElementById("subTotalPrice").innerHTML = weekdayPrice; 

  //Workout prices based on zipcode

  localStorage.setItem("custom_price", weekdayPrice);



  var scrollReceipt = document.getElementById("bookingReceipt"); 
    scrollReceipt.scrollIntoView({
    behavior: 'smooth', // Makes the scroll smooth
    block: 'start',     // Aligns the top of the target element to the top of the visible area
  });

  
}



function initiateStripe() { 
    

    const stripe = Stripe('pk_live_51Mn65cE9OcGjhxyfbPvNA2sn69uZUlLIhnoGnCmB1kr8cM3uYVrcNF4g1gZKswuzyKvl5Bz384Idj3D9CyPOKil800GpCTlFWT'); // Replace with your public Stripe API key
    const elements = stripe.elements();
    
    // Create an instance of the card Element
    const card = elements.create('card', {
        style: {
            base: {
                color: '#32325d',
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSmoothing: 'antialiased',
                fontSize: '16px',
                '::placeholder': {
                    color: '#aab7c4'
                }
            },
            invalid: {
                color: '#fa755a',
                iconColor: '#fa755a'
            }
        }
    });

    // Add an instance of the card Element into the `card-element` <div>
    card.mount('#card-element');
            document.getElementById("paymentSection").classList.remove("d-none"); 

    // Handle real-time validation errors from the card Element
    card.addEventListener('change', function(event) {
        const displayError = document.getElementById('card-errors');
        if (event.error) {

            
        displayError.innerHTML = "<span class='card-error'>"+event.error.message+"</span>"; 
           
        document.getElementById("submit-button").removeAttribute("disabled");
        document.getElementById("submit-button").innerHTML = "Pay Now";
        document.getElementById("submit-button").classList.remove("card-submit-animate"); 
            
        } else {
            displayError.innerHTML = '';
                    document.getElementById("submit-button").removeAttribute("disabled");
        document.getElementById("submit-button").innerHTML = "Pay Now";
        document.getElementById("submit-button").classList.remove("card-submit-animate"); 

       }
    });

    // Handle form submission
    const form = document.getElementById('payment-form');
    form.addEventListener('submit', function(event) {
        
                event.preventDefault();
                document.getElementById("submit-button").setAttribute("disabled","disabled");
                document.getElementById("submit-button").innerHTML = "processing...";
                document.getElementById("submit-button").classList.add("card-submit-animate");

        if(document.getElementById('phone').value == "" || 
           document.getElementById('email').value == "" ||
           document.getElementById('fname').value == "" ||
           document.getElementById('lname').value == "" 
        ){
            
            if(document.getElementById('phone').value == "") { 
                
                document.getElementById('phone').classList.add("glass-form-input-err"); 
            } 
            
            if(document.getElementById('email').value == "") {
                
            document.getElementById('email').classList.add("glass-form-input-err"); 
            } 
            
            if(document.getElementById('fname').value == "") { 
                
                                document.getElementById('fname').classList.add("glass-form-input-err"); 
                } 
            
            if (document.getElementById('lname').value == "") { 
                
                                document.getElementById('lname').classList.add("glass-form-input-err"); 
            }
            
           document.getElementById('card-errors').innerHTML = "<span class='card-error'>Passenger details missing</span>"; 
           
                                       document.getElementById("submit-button").removeAttribute("disabled");
                                                       document.getElementById("submit-button").innerHTML = "Pay Now";
                    document.getElementById("submit-button").classList.remove("card-submit-animate"); 
            
        } else {
            
                    stripe.createToken(card).then(function(result) {
            if (result.error) {
                // Inform the user if there was an error
                const errorElement = document.getElementById('card-errors');
                errorElement.textContent = result.error.message;
            } else {
                // Send the token to your server
                stripeTokenHandler(result.token);
                console.log(result.token); 
            }
        });
            
            
            
        }



    });
    
    
    document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('calendlyForm');
    form.addEventListener('submit', function(event) {
        event.preventDefault();

        const eventType = document.getElementById('event').value;
        const date = document.getElementById('date').value;
        const time = document.getElementById('time').value;
        const email = document.getElementById('email').value;
        const customerFirstName = document.getElementById('customerFirstName').value;
        const customerLastName = document.getElementById('customerLastName').value;
        const phone = document.getElementById('phone').value;
        const pickupLocation = document.getElementById('pickuplocation').value;
        const dropoffLocation = document.getElementById('dropofflocation').value;


    });



        const copyButton = document.getElementById('copyButton');
  const copyText = document.getElementById('confirmationCode');

  copyButton.addEventListener('click', () => {
    // Select the text and copy it
    copyText.select();
    copyText.setSelectionRange(0, 99999); // For mobile devices
    navigator.clipboard.writeText(copyText.value)
      .then(() => {
        // Provide feedback to the user
        copyButton.textContent = "Copied!";
        setTimeout(() => {
          copyButton.textContent = "Copy";
        }, 2000);
      })
      .catch(err => console.error("Copy failed:", err));
  });


      
});

    function stripeTokenHandler(token) {
        // Insert the token ID into the form so it gets submitted to the server
        const form = document.getElementById('payment-form');
        const hiddenInput = document.createElement('input');
        hiddenInput.setAttribute('type', 'hidden');
        hiddenInput.setAttribute('name', 'stripeToken');
        hiddenInput.setAttribute('id', 'stripeToken');
        hiddenInput.setAttribute('value', token.id);
        form.appendChild(hiddenInput);
        
        


        // Submit the form without reloading the page
        
        const fname  =  document.getElementById('fname').value;
        const lname  =  document.getElementById('lname').value;
        const email  =  document.getElementById('email').value;
        const phone  =  document.getElementById('phone').value;
        const pickup  = document.getElementById('originAddress').innerHTML; 
        const dropoff = document.getElementById('destinationAddress').innerHTML;
        const pickupDate = document.getElementById('viewPickupDate').innerHTML;
        const pickupTime = document.getElementById('viewPickupTime').innerHTML;
        const distance = document.getElementById('totalDistance').innerHTML;
        const duration = document.getElementById('totalDuration').innerHTML;
        const price = document.getElementById('totalPrice').innerHTML; 
        
    const pickupLong = document.getElementById('originAddress').getAttribute("originlong");
    const pickupLat = document.getElementById('originAddress').getAttribute("originlat");
    const dropoffLong = document.getElementById('destinationAddress').getAttribute("destinationlong");
    const dropoffLat = document.getElementById('destinationAddress').getAttribute("destinationlat");
        
        /* multiply price by 100 to convert to cents */ 

        const formData = {
            fname: fname,
            lname: lname,
            email: email,
            phone: phone,
            price: price,
            pickup: pickup,
            distance: distance,
            duration: duration,
            dropoff: dropoff,
            pickupDate: pickupDate,
            pickupTime: pickupTime,
            pickupLong: pickupLong,
            pickupLat: pickupLat, 
            dropoffLong: dropoffLong,
            dropoffLat: dropoffLat,
            stripeToken: token.id
        };

        const paymentDataJson = JSON.stringify(formData);
        
        console.log(formData); 
        
        fetch('https://stripe.airportrun.live', { // Replace with your server endpoint
            method: 'POST',
                        headers: {
                'Content-Type': 'application/json'
            },
            body: paymentDataJson
        })
        .then(response => response.json())
        .then(result => {
            if (result.error) {
                const errorElement = document.getElementById('card-errors');
                errorElement.innerHTML = "<span class='card-error'>"+result.error+"</span>";
                            document.getElementById("submit-button").removeAttribute("disabled");
                    document.getElementById("submit-button").classList.remove("card-submit-animate");
                                                                           document.getElementById("submit-button").innerHTML = "Pay Now";

            } else {

              if(result.shopify_confirmation_number) {

                        // Handle successful payment
              document.getElementById('bookingForm').remove(); 
              document.getElementById('bookingReceipt').classList.remove("grid__item");
              document.getElementById('invoicePaymentStatus').innerHTML = 'PAID';
              document.getElementById('invoicePaymentStatus').classList.add('paid__status'); 
              document.getElementById('invoicePaymentLabel').innerHTML = 'RECEIPT';
                document.getElementById('card-errors').innerHTML = '<span class="card-success">Payment successful!</span>';
                document.getElementById("submit-button").classList.remove("card-submit-animate");
                
                document.getElementById("paymentBlock").classList.add("d-none");
                document.getElementById("successBlock").classList.remove("d-none"); 
                                document.getElementById("successBlock").classList.add("complete"); 
                
                console.log(result); 
                
                document.getElementById("confirmationCode").innerHTML = result.shopify_confirmation_number; 

                var scrollReceipt = document.getElementById("bookingReceipt"); 
    scrollReceipt.scrollIntoView({
    behavior: 'smooth', // Makes the scroll smooth
    block: 'start',     // Aligns the top of the target element to the top of the visible area
  });

                
              } else {

                //Handle Unsuccessful payment

                          console.log(result); 

                              const errorElement = document.getElementById('card-errors');
                errorElement.innerHTML = "<span class='card-error'>"+result.stripe_charge_message+"</span>";
                            document.getElementById("submit-button").removeAttribute("disabled");
                    document.getElementById("submit-button").classList.remove("card-submit-animate");
                                                                           document.getElementById("submit-button").innerHTML = "Pay Now";

                setTimeout(function(){

                  errorElement.innerHTML = ""; 
                  
                }, 5000); 


            }
            }
        })
        .catch(error => {
          console.log("Fetch error details:", error); // Logs the error object
            const errorElement = document.getElementById('card-errors');
            errorElement.textContent = 'An error occurred. Please try again.';
            document.getElementById("submit-button").removeAttribute("disabled"); 
                            document.getElementById("submit-button").classList.remove("card-submit-animate");
                                                                                   document.getElementById("submit-button").innerHTML = "Pay Now";
        });
    } 
}

/* initiateStripe(); */ 


/* Shopify API Functions */ 

    if (draftOrderCreated) {
        console.log("Draft order already created, skipping...");
        return; // Prevent multiple executions
    }

    async function createDraftOrder(productId, quantity, customPrice,buttonId) {

      var pickup_location = localStorage.getItem("pickupAddress");
      var dropoff_location = localStorage.getItem("dropoffAddress");
      var pickup_time = localStorage.getItem("pickupTime"); 
      var pickup_date = localStorage.getItem("pickupDate");
      var total_distance = localStorage.getItem("totalDistance"); 
      var total_time = localStorage.getItem("totalTime"); 

      var first_name = localStorage.getItem("first_name"); 
      var last_name = localStorage.getItem("last_name"); 
      var phone = localStorage.getItem("phone"); 
      var email = localStorage.getItem("email");

      let startAddress = JSON.parse(localStorage.getItem("start_address"));
      let endAddress = JSON.parse(localStorage.getItem("end_address"));

      var address_one = ""; 

      if(endAddress.airport) {

        address_one = endAddress.airport; 
      } else {

        address_one = endAddress.street_number+" "+endAddress.route; 
      }

      
    const payload = {
    product_id: productId,  // Replace with actual product ID
    quantity: quantity,
    custom_price: customPrice,  // Replace with actual price

    customer: {
        first_name: ""+first_name+"",
        last_name: ""+last_name+"",
        email: ""+email+"",
        phone: ""+phone+""
    },

    shipping_address: {
        first_name: ""+first_name+"",
        last_name: ""+last_name+"",
        address1: ""+address_one+"",
        address2: "",
        city: ""+endAddress.locality+"",
        province: ""+endAddress.administrative_area_level_1+"",
        country: ""+endAddress.country+"",
        zip: ""+endAddress.postal_code+"",
        phone: ""+phone+""
    },

    pickup_date: ""+pickup_date+"",
    pickup_time: ""+pickup_time+"",
    pickup_location: ""+pickup_location+"",
    dropoff_location: ""+dropoff_location+"",
    total_distance: ""+total_distance+"",
    total_duration: ""+total_time+""
};


      console.log(payload); 
            
        fetch("https://stripe.airportrun.live/proxy/api/index.php", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
body: JSON.stringify(payload)
        })
        .then(response => response.json())
        .then(data => {
            console.log("Draft Order Response:", data);
            if (data.draft_order && data.draft_order.invoice_url) {
                setTimeout(function(){
                          draftOrderCreated = false; // Set flag to reset 
                      // Completely clear localStorage and sessionStorage

                  if(buttonId == "seePrices") { 

                    var cardError = document.getElementById('card-errors');
                    cardError.innerHTML = '';
                    document.getElementById("submit-button").removeAttribute("disabled");
        document.getElementById("submit-button").innerHTML = "Pay Now";
        document.getElementById("submit-button").classList.remove("card-submit-animate");

                                      document.getElementById("seePrices").removeAttribute("disabled");
                document.getElementById("seePrices").innerHTML = "See Prices";
                document.getElementById("seePrices").classList.remove("card-submit-animate"); 


                  } else { 


                     document.getElementById("submit-button").removeAttribute("disabled");
        document.getElementById("submit-button").innerHTML = "Pay Now";
        document.getElementById("submit-button").classList.remove("card-submit-animate");

                                                          document.getElementById("seePrices").removeAttribute("disabled");
                document.getElementById("seePrices").innerHTML = "See Prices";
                document.getElementById("seePrices").classList.remove("card-submit-animate"); 

                         window.location.href = data.draft_order.invoice_url;  
                  
                  }




                  

}, 2000); 
            } else {
                console.error("Error creating draft order:", data);
            }
        })
        .catch(error => console.error("Fetch Error:", error));
    }

    const productId = 50300628107585;

  var checkPrice = parseInt(localStorage.getItem("custom_price")); 
  var serviceCharge = 50; 
  var newPrice = 0;
  var countCall = 0; 
  var totalPrice = 0; 
  var buttonId = event.target.id; 

  console.log(buttonId); 

  if(checkPrice <= serviceCharge) { 
  
     newPrice = 0; 
    totalPrice = newPrice + serviceCharge; 
  } else { 

    newPrice = checkPrice - serviceCharge; 
    totalPrice = newPrice + serviceCharge;
  }

  


    if (newPrice !== null) {

              createDraftOrder(productId, 1, newPrice, buttonId);

    } else {
        console.error("Price not found in localStorage for product ID:", productId);
    }

/* Show Price */ 
        
clickedId.click(); 
        
        
        
        

        
    }
            
            
            
        }





 


    
}

function toggleSwitches(event) {
    var toggle1 = document.getElementById('toggle1');
    var toggle2 = document.getElementById('toggle2');
    var label1 = document.getElementById('destinationContainer1');
    var label2 = document.getElementById('destinationContainer2');
    var switchContainer = document.getElementById('switchContainer');
    var input1 = document.getElementById('destination1');
    var input2 = document.getElementById('destination2');
    
    
        // Toggle the checked states with IDs
        
    var clickedId = event.target.id;
    
    console.log("clicked"+clickedId); 
    
    if(clickedId == "toggle1") { 
        
            if (toggle1.checked) {
        toggle2.checked = false;

    } else {
        toggle2.checked = true;
    }
    
    input1.setAttribute("aria-describedby","destination20");
    input1.setAttribute("id","destination20");
    
    var tempInput = document.getElementById("destination20"); 
    
    input2.setAttribute("aria-describedby","destination1");
    input2.setAttribute("id","destination1");
    
    
    tempInput.setAttribute("aria-describedby","destination2"); 
    tempInput.setAttribute("id","destination2"); 
        
    }
    
    else { 
     
                if (toggle2.checked) {
        toggle1.checked = false;
    } else {
        toggle1.checked = true;
    }
    
    
    input1.setAttribute("aria-describedby","destination20");
    input1.setAttribute("id","destination20");
    
    var tempInput = document.getElementById("destination20"); 
    
    input2.setAttribute("aria-describedby","destination1");
    input2.setAttribute("id","destination1");
    
    
    tempInput.setAttribute("aria-describedby","destination2"); 
    tempInput.setAttribute("id","destination2"); 
    
        
    }



    


    // Swap the positions of the labels
    /* if (toggle1.checked) {
        switchContainer.insertBefore(label2, label1);
    } else {
        switchContainer.insertBefore(label1, label2);
    } */
}

 function initAutocomplete() {
    // Get the input element
    var input = document.getElementById('destination2');
    
    // Create the autocomplete object
    var autocomplete = new google.maps.places.Autocomplete(input);
    
    // Specify the fields to be returned
    autocomplete.setFields(['address_components', 'geometry', 'name']);
    
    // Set up a listener to handle when a user selects an address
    autocomplete.addListener('place_changed', function() {
        // Get the place details from the autocomplete object
        var place = autocomplete.getPlace();
        
        //Get all elements of this address
        
        // Check if the place has geometry information
        if (place.geometry) {
            var lat = place.geometry.location.lat();
            var lng = place.geometry.location.lng();
            console.log('Latitude: ' + lat);
            console.log('Longitude: ' + lng);
            
            input.setAttribute("long", lng);
            input.setAttribute("lat", lat);
            
        } else {
            console.log('No geometry information available for this place.');
        }
    });
}

document.addEventListener("DOMContentLoaded", function () {
    /*** 🗓️ DATE LOGIC ***/
    function setupDate() {
        let dateInput = document.getElementById("pickupDate");
        let today = new Date().toISOString().split("T")[0];

        // Prevent past dates
        dateInput.setAttribute("min", today);

        // Default to today's date
        dateInput.value = today;
    }

    /*** ⏰ TIME LOGIC (ONLY SELECTING THE CORRECT TIME) ***/
    function setupTime() {
        let timeSelect = document.getElementById("pickupTime");
        let now = new Date();
        now.setMinutes(now.getMinutes() + 30); // Add 30 min buffer
        now.setSeconds(0);
        now.setMilliseconds(0);

        let hours = now.getHours();
        let minutes = now.getMinutes();

        // Round minutes to nearest 30-minute mark
        minutes = minutes < 30 ? "30" : "00";

        // If rounding to "00", increment the hour
        if (minutes === "00" && now.getMinutes() >= 30) {
            hours += 1;
        }

        // Convert to 12-hour format
        let period = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12; // Convert 0 to 12 for AM

        // Construct formatted time string
        let adjustedTime = `${hours}:${minutes} ${period}`;

        // Find and select the closest valid option (skip disabling times)
        let options = timeSelect.options;
        for (let i = 0; i < options.length; i++) {
            if (options[i].value === adjustedTime) {
                options[i].selected = true;
                break;
            }
        }
    }

    /*** 🚫 DISABLE PAST DATES LOGIC ***/
    function disablePastDates() {
        let dateInput = document.getElementById("pickupDate");
        let today = new Date().toISOString().split("T")[0];

        // Disable past dates, ensure the date is always set to today
        dateInput.setAttribute("min", today);
        dateInput.value = today;
    }

    /*** 🛠️ INIT ***/
    setupDate();
    setupTime();
    disablePastDates();
});










// Initialize the autocomplete functionality once the DOM has fully loaded
setTimeout(function(){
    initAutocomplete();
    
},2000);
